import React, { Component } from "react";
import { flushSync } from "react-dom";
import "./ConversationStyleSheet.css";
import DOMPurify from "dompurify";
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import uuid from "react-uuid";
import ConversationHeader from "./ConversationHeader";
import Conversation from "./Conversation";
import InputBox from "./InputBox";
import dayjs from "dayjs";
import xmppService from "../Services/XMPPService";
import HWLog from "../HWLibrary/HWLog";
import { MyContext } from "../../context/Mycontext";
import { MessageType } from "./MessageBoxTypes/Message";
import apiService from "../Services/APIService";
import { Snackbar } from "@mui/material";
import SendChatTranscriptForm from "./SendChatTranscriptForm";
import menuIcon from "../../images/menu-icon.svg";
import resetImage from "../../images/home.svg";
import homeImage from "../../images/home.png";
import gifImage from "../../images/gif.svg";
import settingImage from "../../images/settings.svg";
import Popup from "./Popup";
import Picker from "emoji-picker-react";
import { Tooltip } from "@mui/material";
import { Modal } from "react-modal-overlay";
import "react-modal-overlay/dist/index.css";
import Typography from "@mui/material/Typography";
import { isNullOrUndefined, saveUILogs } from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";
import pinAttachmentIcon from '../../assets/svgs/pin-attachment-icon.svg'
import docAttachmentIcon from '../../assets/svgs/document-attachment-icon.svg'
import CircularProgress from "@mui/material/CircularProgress";
import { CometdActions } from "../../cometD/cometD-action";
import CometDMiddleWare from "../../cometD/cometD-middleware";
import { _noop, MAIN_MENU_MESSAGE, supportedFileFormats } from "../../utils/Constants/Constants";
import ReloadSessionContainer from "../../utils/ReloadSessionContainer/ReloadSessionContainer";
import TypingIndicator from "../CommonUtils/TypingIndicator";

var tempFilesArray = [];
var internetListenerAdded = false;
var healthPingCounter = 0;
var isMobile = window.screen.width < 610;
var timerMessages = null;
var timerMessageCounter = 0;
var agentNotificationMessageIds = [];
var agentNotificationMessageIdsCopy = [];
var loopMessagerecived = false

class ConversationPage extends CometDMiddleWare {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.file = React.createRef();
    this.name = "ConversationPage";
    this.state = {
      messages: [],
      mainMenuMessage:"मुख्य मेन्यू",
      xmppMessageHistory: [],
      previewFiles: [],
      isConversationClosed: false,
      isChatClose: false,
      showSnackBar: false,
      showSendChatTranscriptForm: false,
      showCloseDialog: false,
      isFetchingMessages: true,
      isReset: false,
      showEmoji: false,
      showGif: false,
      isLoading: false,
      isOnlyEmoji: false,
      showSetting: false,
      radioValue: "sendIt",
      finalValue: null,
      messageLoader: false,
      refresher: false,
      isFetchingMessagesBelow: false,
      showChatStatusLang: this?.props?.config?.chatStatusLangtoggle || true,
      showChatStatusAttachment: s360ConfigService?.config?.alwaysShowAttachment
        ? true
        : false,
      disableLoader: false,
      showConversationFlow: false,
      customerAckObj: {},
      showAckMsg: false,
      setMsgValue: {},
      showMsgDelivered: false,
      showReloadPopup: false,
      showLoaderBotPopup: false,
      showErrorMsg: "",
      hideNextMessage: false,
      showTypingIndicator: false,
      isTypingPublished: false
      // showMessagesFromStart:true,
    };
    if (this.props.config?.notification?.audio !== undefined) {
      this.audio = new Audio(this.props.config.notification.audio);
    }
    this.conversationRef = React.createRef();
    this.conversationFooterRef = React.createRef();
    this.emojiRef = React.createRef();
    this.logsInterval = null
  }
  defaultMessage = "Type a message...";
  loaderTimeOut = 0;
  msgIdTimer = {};
  clearMsgIds = {};
  // assigning context to current page context
  static contextType = MyContext;

  componentDidMount() {
    saveUILogs({ 
      timestamp: new Date().toISOString(),
      message: "LIVECHAT UI: ConversationsPage loaded"
    })
    //NOTE : Enhancement 1
    if (!internetListenerAdded && this?.props?.config?.healthCheck) {
      this.handleConnectionChange();
    }
    if (this?.props?.config?.healthCheck) {
      window.addEventListener("online", this.handleConnectionChange);
      window.addEventListener("offline", this.handleConnectionChange);
    }

    setTimeout(
      () => this.setState(() => ({ isFetchingMessagesBelow: false })),
      this.loaderTimeOut
    );

    // if config.designDetails?.newLineOnEnter is true then set radioValue to newLine
    if (!!this.props.config.designDetails?.newLineOnEnter)
      this.setState({ radioValue: 'newLine' })

    this.initialActionCometd(this.props.conversation);

    // this.showSnackBarWithMessage("HI Welcome To Simplify360");
    const isAgentWaiting = localStorage.getItem("agentWaiting");
    const isAgentConnected = localStorage.getItem("agentConnected");
    if (this?.props?.uniboxSingleRefresh) {
      this.parseUniboxSinleRefreshRespone();
    }

    if (!isAgentConnected && isAgentWaiting) {
      if (
        s360ConfigService.config.agentNotificationMessages !== undefined &&
        s360ConfigService.config.agentNotificationMessages.length > 0
      ) {
        let tempIntervalMessages =
          s360ConfigService.config.agentNotificationMessages;
        agentNotificationMessageIds = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        agentNotificationMessageIdsCopy = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        //TIMERTODO : CHECKING FOR FILED PRESENT AND HAS VALUES
        //TIMERTODO : CALL A FUNCTION TO STORE ID'S IN ARRAY AND CREATEINTERVAL
        tempIntervalMessages.map((oneIntervalMessage) => {
          this.createDynamicIntervals(oneIntervalMessage);
        });
      }
    }

    if (!!s360ConfigService.config.designDetails?.hideButtonBoxShadow) {
      document.documentElement.style.setProperty(
        '--s360-disabled-btn-border-color', 
        s360ConfigService.config.designDetails.buttonBorderColor
      );
    }

    // update main menu message in context so that clicking home button shows the correct message
    this.context.updateMainMenuMessage(
      MAIN_MENU_MESSAGE[this.props.config?.mainMenuMessage || "Main Menu"]?.["English"] || this.props.config?.mainMenuMessage || "Main Menu"
    );

    // logs interval to log every 5 seconds until first messages are rendered
    this.logsInterval = setInterval(() => {
      this.props.showLogsModal()
    }, 5000);
  }

  componentDidUpdate(prevProps, prevState) {
    //   if(this?.props?.uniboxSingleRefresh){
    //     this.parseUniboxSinleRefreshRespone();
    // }
    const { showAckMsg, setMsgValue } = this.state;
    console.log(
      prevProps.uniboxSingleRefresh,
      this.props.uniboxSingleRefresh,
      "IN CONVERSARION PAGE PROPS"
    );
    let currentTimer = setMsgValue?.message?.sentTimestamp;

    console.log(
      "COMETD-LOG-CHECK: 3.1 in componentDidUpdate in conversation page"
    );

    if (prevProps.isIframeClose !== this.props.isIframeClose) {
      if (s360ConfigService.config.hideIcon) {
        this.props.resetIframe();
      }

      this.parseSessionCloseResponse({
        sessionId: this.props.sessionIdForClose,
      });
    }

    //retry options
    console.log(
      "prevState.showAckMsg !== showAckMsg",
      prevState.showAckMsg,
      showAckMsg
    );
    if (prevState.showAckMsg !== showAckMsg && this?.props?.config?.chatRetry) {
      let tempTimer = setTimeout(() => {
        this.handleAckRetry();
      }, 1000);

      this.clearMsgIds = { ...this.msgIdTimer, [currentTimer]: tempTimer };
      this.setState({ showAckMsg: false });
    }
    
    // MARK: Enable to log when UI first renders
    if (!prevState.messages?.length && this.state.messages.length> 0) {
      // alert("first message load")  // can be enabled in dev
      saveUILogs({
        timestamp: new Date().toISOString(),
        message: "LIVECHAT UI: UI will render messages now...",
      })

      if (this.logsInterval)
        clearInterval(this.logsInterval);

    }
  }

  componentWillUnmount() {
    this.removeHelathPingTimer();
    Object.keys(this.clearMsgIds).map((k) => {
      clearTimeout(this.clearMsgIds[k]);
    });

    if (this.props.config.healthCheck) {
      window.removeEventListener("online", this.handleConnectionChange);
      window.removeEventListener("offline", this.handleConnectionChange);
    }

    if (this.logsInterval) {
      clearInterval(this.logsInterval);
    }
  }

  handleUpdateTypingStatus(isTyping = false) {
    if (isTyping && this.state.isTypingPublished)
      // typing is true but already typing published, then don't publish again
      return
  
    if (!isTyping && !this.state.isTypingPublished)
      // typing is false & also typing is not published then no need to publish
      return

    let sessionId = this.props?.activeConversation?.sessionId || ""
    if (!sessionId) {
      HWLog.warn("No SessionId available to send typing status");
      return;
    }
    
    // send typing status through cometD
    const { sendTypingIndicatorMessage } = CometdActions(this.context.cometdInstance, this.context.userData)
    sendTypingIndicatorMessage(sessionId, isTyping);
    this.setState({ isTypingPublished: isTyping });
  }

  handleAckRetry = () => {
    const { messages, setMsgValue } = this.state;

    let initialMsgArray = [];

    messages.map((el) => {
      let newEl = { ...el };
      if (
        newEl?.message?.id &&
        setMsgValue.hasOwnProperty(newEl.message?.id) &&
        !newEl.message.showSingleTick
      ) {
        newEl.message["showSingleTick"] = false;
      }
      initialMsgArray.push(newEl);
    });

    this.setState({ messages: initialMsgArray });
  };

  handleRadio = (e) => {
    if (e.target.id == "sendIt") {
      this.setState({ radioValue: "sendIt" });
    } else {
      this.setState({ radioValue: "newLine" });
    }
  };

  handleSettingClose = () => {
    this.setState({ showSetting: false });
  };
  handleButtonClick = (event) => {
    this.setState({ showSetting: event.currentTarget });
  };

  handleFileScan = async (file) => {
    let regexforFileExtension = /(?:\.([^.]+))?$/;

    if (
      !supportedFileFormats.includes(regexforFileExtension.exec(file.name)[0])
    ) {
      this.showSnackBarWithMessage(`${file.name} File format not supported.`);
      return;
    }
    this.setState({ isFetchingMessages: true });

    fetch("https://api.cloudmersive.com/virus/scan/file", {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Apikey: process.env.REACT_APP_CLOUDMERSIVE_API_KEY,
      },
      body: file,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("datadata", data);
        this.setState({ isFetchingMessages: false });
        if (data.CleanResult) {
          if (file.size > 10485760) {
            this.showSnackBarWithMessage(
              `File size exceeds maximum limit 10 MBs and the file is ${file.name}`
            );
          } else {
            tempFilesArray.push(...this.state.previewFiles, file);
            const uploadFiles = tempFilesArray.reduce(
              (accumulator, current) => {
                if (!accumulator.find((item) => item.name === current.name)) {
                  accumulator.push(current);
                }
                return accumulator;
              },
              []
            );

            this.setState({ previewFiles: uploadFiles });
            this.file.current.value = "";
          }
        } else {
          this.showSnackBarWithMessage(
            `Upload blocked: Malicious file detected, for security reasons and the file is ${file.name}`
          );
        }
      })
      .catch((error) => {
        console.log("Error in handleFileScan", error);
        this.setState({ isFetchingMessages: false });
        this.showSnackBarWithMessage(
          `Something went wrong, Please try some other files`
        );
      });
  };

  onFileSelect = async (e) => {
    if (e.target.files) {
      let files = e.target.files;
      for (var i = 0; i < files.length; i++) {
        this.handleFileScan(files[i]);
      }
      if (tempFilesArray.length === 0) {
        tempFilesArray = [];
        return;
      }
    }
  };

  onRemovePreviewFile = (file) => {
    let previewFiles = this.state.previewFiles || [];
    previewFiles = previewFiles.filter(
      (previewFile) => previewFile.name !== file.name
    );
    tempFilesArray = [];
    this.setState({ previewFiles: previewFiles });
  };

  initialActionCometd = (conversation) => {
    //NOTE : Enhancement 2
    if (this?.props?.config?.healthCheck) {
      this.agentHealthPingTimerId = setInterval(async () => {
        this.startFetchingHealthPings();
      }, 1000 * 60);
    }

    console.log(conversation.sessionId, "conversation.sessionId");
    if (
      conversation.sessionStatus === "New" &&
      parseInt(localStorage.getItem("CurrentActiveSession")) !==
        parseInt(conversation.sessionId)
    ) {
      console.log(
        "COMETD-LOG: IN CONVERSATION PAGE GOT A NEW SESSION",
        this.props.conversation
      );
      this.parseBotReplyResponse(conversation);
    } else {
      console.log(
        `COMETD-LOG: IN CONVERSATION PAGE GOT A ${conversation?.sessionStatus?.toUpperCase()} SESSION`,
        this.props.conversation
      );
      this.fetchConversationHistoryCometd();
      //call history
    }
    localStorage.setItem("CurrentActiveSession", conversation.sessionId);
    //if active/previous ---> call history
    //if new use conversation details itself
  };

  disableOnAgentConnections = () => {
    console.log("disableOnAgentConnections is getting called");
    localStorage.setItem("agentConnected", true)
    this.setState({
      showChatStatusLang: false,
      showChatStatusAttachment: s360ConfigService?.config?.alwaysShowAttachment
        ? true
        : s360ConfigService.config.hideAttachment
        ? false
        : true,
    });
  };

  fetchConversationHistoryCometd = (lastFetchMessageId) => {
    let sessionInfo = this.props.activeConversation;
    const { fetchHistoryCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
    fetchHistoryCMD(sessionInfo, lastFetchMessageId, 30);
    saveUILogs({ 
      timestamp: new Date().toISOString(),
      message: "LIVECHAT UI: HISTORY_REQUEST called"
    })
  };

  updateComponent = (data) => {
    // this.removePreviousEvent(true)
    console.log("COMETD-LOG:RECIEVED MESSAGE FROM COMETD", data.message.data);

    this.cometdActions(JSON.parse(data.message.data));
    console.log(
      "COMETD-LOG:RECIEVED MESSAGE FROM COMETD AFTER",
      data.message.data
    );
  };

  parseCustomerMsgAck = (message) => {
    const { setMsgValue, messages } = this.state;
    console.log(
      "parseCustomerMsgAck",
      message,
      setMsgValue,
      setMsgValue.hasOwnProperty(message.msgId),
      message?.msgId
    );

    if (this?.props?.config?.chatRetry) {
      const initialMsgArray = [];

      if (
        message &&
        message?.msgId &&
        setMsgValue.hasOwnProperty(message.msgId)
      ) {
        messages.map((el) => {
          let ele = { ...el };
          console.log("el.id", el.id, message.msgId, el.id == message.msgId);
          if (el.id == message.msgId) {
            ele.message["showSingleTick"] = true;
          }
          initialMsgArray.push(ele);
        });
        this.setState({ messages: initialMsgArray });
      }
    }
  };

  parseBotFromCustomerMsgAck = (message) => {
    const { messages, setMsgValue } = this.state;

    console.log(
      "hvjv",
      message,
      setMsgValue.hasOwnProperty(message.msgId),
      message?.msgId
    );

    if (this?.props?.config?.chatRetry) {
      if (setMsgValue?.message?.showDoubleTick) {
        return;
      }

      let initialMsgArray = [];

      // let temp = setMsgValue[message.msgId];

      if (
        message &&
        message?.msgId &&
        setMsgValue.hasOwnProperty(message.msgId)
      ) {
        messages.map((el) => {
          let ele = { ...el };
          console.log(
            "el.id::two",
            el,
            el.id,
            message.msgId,
            el.id == message.msgId
          );
          if (el.id == message.msgId) {
            ele.message["showDoubleTick"] = true;
            ele.message["showSingleTick"] = true;
            delete setMsgValue[message.msgId];
          }
          initialMsgArray.push(ele);
        });
        this.setState({ messages: initialMsgArray });
      }
    }
  };

  parseAckAllAgentReply = () => {
    const { messages } = this.state;

    let tempArray = [];

    console.log("parseAckAllAgentReply", messages);
    if (this?.props?.config?.chatRetry) {
      messages.map((el) => {
        let ele = { ...el };
        if (ele.message.showSingleTick) {
          ele.message.showDoubleTick = true;
        }
        tempArray.push(ele);
      });
      this.setState({ messages: tempArray });
    }
  };

  //NOTE : Enhancement 3
  parseSessionReload = (config) => {
    console.log("config", config);
    this.setState({ showReloadPopup: true });
  };

  parseUniboxSinleRefreshRespone = function () {
    localStorage.setItem("agentWaiting", true);
    const isAgentWaiting = localStorage.getItem("agentWaiting");
    const isAgentConnected = localStorage.getItem("agentConnected");
    if (!isAgentConnected && isAgentWaiting) {
      if (
        s360ConfigService.config.agentNotificationMessages !== undefined &&
        s360ConfigService.config.agentNotificationMessages.length > 0
      ) {
        let tempIntervalMessages =
          s360ConfigService.config.agentNotificationMessages;
        agentNotificationMessageIds = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        agentNotificationMessageIdsCopy = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        //TIMERTODO : CHECKING FOR FILED PRESENT AND HAS VALUES
        //TIMERTODO : CALL A FUNCTION TO STORE ID'S IN ARRAY AND CREATEINTERVAL
        tempIntervalMessages.map((oneIntervalMessage) => {
          this.createDynamicIntervals(oneIntervalMessage);
        });
      }
    }
  };

  cometdActions = (message) => {
    if (!message) return;
    console.log("CONVESSAGE: ", message, this.state.isReset);
    //  To add more cases, add it in XMPPService class.
    switch (message.command) {
      case "HISTORY_RESPONSE":
        this.parseMessageHistoryResponse(message);
        // if (!this.state.isReset) this.parseMessageHistoryResponse(message);
        break;
      case "UNIBOX_SINGLE_REFRESH":
        this.parseUniboxSinleRefreshRespone();
        break;
      case "PING_RESPONSE":
        this.parseAgentStatusPingResponse(message);
        break;
      case "SESSION_CLOSE": {
        console.log("SESS_BUG:1.USER HAS TYPED !QUIT/SESSION ENDED");
        this.parseSessionCloseResponse(message);
        break;
      }
      case "CHAT_STATUS":
        this.parseChatStatusResponse(message);
        break;
      case "BOT_REPLY":
        this.parseBotReplyResponse(message);
        break;
      case "AGENT_REPLY":
        this.parseAgentReplyResponse(message);
        break;
      case "SESSION_NOTIFICATION":
        this.parseAgentReplyResponse(message);
        break;
      case "TYPING_INDICATOR":
        this.parseTypingIndicatorResponse(message);
        break;
      case "SEND_CHAT_TRANSCRIPT_RESPONSE":
        this.parseChatTranscriptResponse(message);
        break;
      case "SURVEY_TRIGGER":
        let messageTime = new Date();
        let sessionId = message.sessionId || "";
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) {
          HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
          return;
        }
        // console.log("5.TRIGERRED  BOT MESSAGE    BEFORE ADDING TO ARRAY",message)
        if (!message.id) {
          message.id = uuid();
        }
        message.id = message.id + "";
        message.convoType = "CLOSE";
        message.message.sentTimestamp = messageTime.getTime();
        // Message.message.text = "hello";

        // console.log("6.TRIGERRED BOT MESSAGE    AFTER ADDING TO ARRAY",message)
        this.addMessagesToList([message]);
        this.props.parseSurveyTriggerResponse(message);
        break;
      case "ACK_BOT2CUSTOMER":
        this.parseCustomerMsgAck(message);
        break;
      case "ACK_CUSTOMER_REPLY":
        this.parseBotFromCustomerMsgAck(message);
        break;
      case "ACK_CUSTOMER_MESSAGES_FOR_SESSION":
        this.parseAckAllAgentReply(message);
        break;
      case "CREATE_SESSION": {
        console.log(
          "SESS_BUG:12. GOT A RESPONSE FROM XMPP FOR CREATE_SESSION--->",
          message
        );
        this.onCreateSessionResponse(message);
        break;
      }
      case "SESSION_RELOAD": {
        if (this.props.config.healthCheck) this.parseSessionReload(message);
        break;
      }
      default:
        break;
    }
    this.setState({ isFetchingMessagesBelow: false });
  };

  // returnCount =()=>{
  //   if(isNullOrUndefined(localStorage.getItem("count")))
  //   {
  //     localStorage.setItem("count",1)
  //     return 1;
  //   }
  //   else{
  //     localStorage.setItem("count",localStorage.getItem("count")+1)
  //     return localStorage.getItem("count")+1
  //   }
  // }
  onMessageSend = () => {
    //this is where the loader should be made true
    console.log("emoji...");

    let isMediaAttached = (this.state.previewFiles || []).length !== 0;
    console.log("media", isMediaAttached);

    let hasTextMessage = !(
      !this.messageRef.current.value ||
      !this.messageRef.current.value.trim() ||
      this.messageRef.current.value === this.defaultMessage
    );
    console.log("txt...", hasTextMessage);
    if (!isMediaAttached && !hasTextMessage) {
      return;
    }

    if (hasTextMessage && !isMediaAttached) {
      console.log("emm", this.messageRef.current.value.trim());
      this.sendMessage(this.messageRef.current.value.trim());
    } else if (isMediaAttached) {
      console.log("emoji");
      let textMessage = hasTextMessage
        ? this.messageRef.current.value.trim()
        : null;
      this.setState({ isLoading: true }, () => {
        this.sendMessageWithAttachemnts(
          this.state.previewFiles,
          textMessage
        ).finally(() => {
          tempFilesArray = [];
          this.setState({ isLoading: false, previewFiles: [] });
        });
      });
    }
    this.messageRef.current.value = "";
    console.log("this.messageRef.current.value", this.messageRef.current.value);

    this.setState({ showEmoji: false });

    // document.getElementById('tx').style.height  = 34+"px";
    // document.getElementById('tx1').style.height = 24 +"px";
    // document.getElementById('img2').style.marginBottom = 0 + "px";
    // document.getElementById('emoji').style.marginBottom = 0 + "px";
    // document.getElementById('home').style.marginBottom = 0 + "px";
  };

  handleClose = () => {
    this.setState({ showGif: false });
  };

  showGIF = () => {
    let check = !this.state.showGif;
    this.setState({ showGif: check });
    if (this.state.showEmoji === true) {
      this.setState({ showEmoji: false });
    }
  };

  showSetting = () => {
    let check = !this.state.showSetting;
    this.setState({ showSetting: check });
    if (this.state.showEmoji === true) {
      this.setState({ showEmoji: false });
    }
  };

  onEmojiClick = (event, emojiObject) => {
    console.log(emojiObject, "here");
    const ref = this.messageRef.current;
    ref?.focus();

    const start = ref.value.substring(0, ref.selectionStart);
    const end = ref.value.substring(ref.selectionStart);
    console.log("stt", start, end);
    const txt = start + emojiObject.emoji + end;
    localStorage.setItem("txt", txt);
    ref.value = txt;
    // this.setState({
    //   finalvalue: ref.value,
    // });
    localStorage.setItem("finalvalue", ref.value);
    // this.setState({...this.state,showEmoji:true})
  };

  showEmoji = () => {
    console.log("123");
    let chk = this.state.showEmoji ? false : true;
    this.setState({ showEmoji: chk });
    if (chk == true && this.state.showGif === true) {
      this.setState({ showGif: false });
    }
  };

  attachmentSVGImage = (showPinStyleAttachmentIcon = false) => 
    showPinStyleAttachmentIcon ? pinAttachmentIcon : docAttachmentIcon

  emojiSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     // width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>

    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="#333333"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M9.40192 13.5C9.66523 13.9561 10.0439 14.3348 10.5 14.5981C10.9561 14.8614 11.4734 15 12 15C12.5266 15 13.0439 14.8614 13.5 14.5981C13.9561 14.3348 14.3348 13.9561 14.5981 13.5"
          stroke="#333333"
          stroke-width="2"
          stroke-linecap="round"
        />
        <rect
          x="6.875"
          y="7.875"
          width="3.25"
          height="2.25"
          rx="1.125"
          fill="#333333"
          stroke="#333333"
          stroke-width="0.25"
          stroke-linecap="round"
        />
        <rect
          x="13.875"
          y="7.875"
          width="3.25"
          height="2.25"
          rx="1.125"
          fill="#333333"
          stroke="#333333"
          stroke-width="0.25"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  onSendChatTranscriptClick = () => {
    this.setState({ showSendChatTranscriptForm: true });
  }

  sendChatTranscript = (emailId) => {
    this.setState({ showSendChatTranscriptForm: false });
    if (!emailId) {
      return;
    }
    
    const { sendChatTranscriptCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
    sendChatTranscriptCMD(this.props.activeConversation, emailId);
  };

  resetChat = () => {
    this.setState(
      { isReset: true, isChatClose: !this.state.isChatClose },
      () => {
        this.closeConversation();
        // this.startNewConversation();
      }
    );
  };

  // componentDidUpdate(prevProps, prevState) {
  //   // if(this.state.messageLoader!== prevState.messageLoader){
  //   //   if(this.state.messageLoader){
  //   //    console.log("append messages here with loader")
  //   //     const prevMessages = this.state.messages
  //   //     this.setState({messages:[...prevMessages]})
  //   //   }
  //   //   else{
  //   //     console.log("remov messages here with loader and update state again")
  //   //   }
  //   // }

  //   console.log(
  //     "data...this.state.isConversationClose",
  //     this.state.isChatClose
  //   );
  //   console.log(
  //     "data...this.state.isConversationCloseed",
  //     this.state.isConversationClosed
  //   );
  //   if (prevState.isChatClose !== this.state.isChatClose) {
  //     console.log("data...working");
  //     // this.startNewConversation();
  //   }
  //   // if(this.state.isReset && this.state.messages.length === 0)
  //   // {
  //   //   this.resetChat()
  //   // }
  // }

  // closeConversationClick = () => {
  //   this.setState({ showCloseDialog: true, open: true });
  //    };

  closeConversationClick = () => {
    // this.setState({ showCloseDialog: true, open: true });

    localStorage.removeItem("finalvalue");
    this.setState({
      showCloseDialog: false,
      open: false,
      isReset: true,
      // isChatClose: !this.state.isChatClose,
    });

    let sessionId =
      this.props.activeConversation && this.props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    console.log("CALLING RESET API", sessionId);

    const { closeSessionCMD } = CometdActions(this.context.cometdInstance, this.context.userData)

    closeSessionCMD(sessionId);
    // .then((message) => {
    //   console.log("message from XMPP", message);
    //   // this.closeConversation()
    //   this.startNewConversation();
    // })
    // .catch((error) => {
    //   this.showSnackBarWithMessage(
    //     "Could not close coversation, please try again."
    //   );
    // });

    console.log("CALLING RESET API DONE");
    // if (s360ConfigService?.config?.secondaryConfig) {
    //   window.parent.postMessage(
    //     {
    //       switchBotToDefault: "true",
    //     },
    //     "*"
    //   );
    // }
  };

  handleSnackbarClose = () => {
    this.setState({ showSnackBar: false });
  };

  showSnackBarWithMessage = (message) => {
    this.setState({ snackBarMessage: message, showSnackBar: true });
  };

  isActiveConversation = () => {
    let isClosed =
      (this.props.activeConversation &&
        this.props.activeConversation.active != null &&
        this.props.activeConversation.active !== undefined &&
        this.props.activeConversation.active === false) ||
      this.state.isConversationClosed;
    return !isClosed;
  };

  sendTimelyMessages = () => {
    timerMessageCounter++;
    let messageToShow = "Please wait our agents are busy.";
    let messageTime = new Date();
    let chatInfoMessage = {
      message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
      id: `agent-info-message${messageTime}`,
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "TEXT",
      syntheticMessage: true,
    };
    this.addMessagesToList([chatInfoMessage]);
    if (timerMessageCounter > 5) {
      if (timerMessages !== null) {
        clearInterval(timerMessages);
      }
    }
  };
  createInfoMessage = (id, message, interval, loop, intervalToClear) => {
    console.log(
      "battman",
      id,
      agentNotificationMessageIds,
      loop,
      intervalToClear
    );
    //TIMERTODO create and push message
    if (agentNotificationMessageIdsCopy.includes(id)) {
      let messageToShow = message;
      let messageTime = new Date();
      let chatInfoMessage = {
        message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
        id: `agent-info-message${id}+${messageTime.getTime()}`,
        type: MessageType.info,
        timestamp: messageTime.getTime(),
        convoType: "TEXT",
        syntheticMessage: true,
      };
      this.addMessagesToList([chatInfoMessage]);
      if (!loop) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      } else if (loop && loopMessagerecived !== id) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      }
    }
    // clear id value in array id loop false
  };

  setLoopMessageInterval = (id, message, interval, loop) => {
    agentNotificationMessageIds[agentNotificationMessageIds.indexOf(id)] =
      setInterval(() => {
        this.createInfoMessage(id, message, interval, loop);
      }, interval * 1000);
  };

  setNormalMessageInterval = (id, message, interval, loop) => {
    let tempinterval = setInterval(() => {
      this.createInfoMessage(id, message, interval, loop, tempinterval);
    }, interval * 1000);
  };

  createDynamicIntervals = (data) => {
    const { id, message, interval, loop } = data;
    //TIMERTODO if loop recived make looprecieved variable true
    if (loop && !loopMessagerecived) {
      this.setLoopMessageInterval(id, message, interval, loop);
      loopMessagerecived = id;
    } else {
      // console.log(agentNotificationMessageIdsCopy,id,index,"agentNotificationMessageIdsCopy")
      this.setNormalMessageInterval(id, message, interval, loop);
    }
  };

  //NOTE : Enhancement 4
  handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "offline") {
      this.setState({
        showLoaderBotPopup: true,
        showErrorMsg:
          "Seems you lost your internet connection Please check your network",
      });
    } else if (condition === "online") {
      this.setState({ showLoaderBotPopup: false });
      if (internetListenerAdded) {
        this.setState({ showReloadPopup: true });
      }
    }

    internetListenerAdded = true;
  };

  // configure = () => {
  //   this.startFetchingHealthPings()
  //   // xmppService
  //   //   .configure(this.onXMPPMessage)
  //   //   .then(() => {
  //   //     this.fetchConversationHistory();
  //   //   })
  //   //   // .then(() => {
  //   //   //   return this.startFetchingHealthPings();
  //   //   // })
  //   //   .catch((error) => {
  //   //     //  console.log(error);
  //   //     HWLog.error(error, "Conversation: Component Did Mount: Error: ");
  //   //   });
  // };

  isOnSameDay = (date, anotherDate) => {
    return (
      dayjs.unix(date).format("YY MMM DD") ===
      dayjs.unix(anotherDate).format("YY MMM DD")
    );
  };
  disablePreviousButtonsOnHistory = () => {
    let enabledLastBotMessage = false;
    console.log(
      this.state.messages,
      "only enable last message group if from bot"
    );
    let messages = this.state.messages;
    if (messages.length > 0) {
      if (messages.length === 1) {
        messages.map((m) => (m.disabled = false));
      } else {
        for (let i = messages.length - 1; i >= 0; i--) {
          if (enabledLastBotMessage) {
            messages[i].disabled = true;
          } else {
            if (messages[i].creator === "BOT") {
              messages[i].disabled = false;
              enabledLastBotMessage = true;
            }
          }
        }
      }
    }
    console.log(messages, "loggmessages-conversationPage");

    this.setState({ messages: messages });
  };
  // fetchConversationHistory = (lastFetchMessageId) => {
  //   let sessionInfo = this.props.activeConversation;
  //   console.log("inn", sessionInfo);
  //   console.log("lastFetch", lastFetchMessageId);
  //   console.log("CALLING HISTORY API");

  //   // let messageHistory = (this.state.xmppMessageHistory || [])
  //   // let lastFetchMessageId = messageHistory[messageHistory.length - 1];
  //   return xmppService.fetchConversationHistory(
  //     sessionInfo,
  //     lastFetchMessageId,
  //     30
  //   );
  //   console.log("CALLING HISTORY API DONE");
  // };

  // onXMPPMessage = (message) => {
  //   if (!message) return;
  //   console.log("CONVESSAGE: ", message);
  //   //  To add more cases, add it in XMPPService class.
  //   switch (message.command) {
  //     case "HISTORY_RESPONSE":
  //       if (!this.state.isReset) this.parseMessageHistoryResponse(message);
  //       break;
  //     case "PING_RESPONSE":
  //       this.parseAgentStatusPingResponse(message);
  //       break;
  //     case "SESSION_CLOSE": {
  //       console.log("SESS_BUG:1.USER HAS TYPED !QUIT/SESSION ENDED");
  //       this.parseSessionCloseResponse(message);
  //       break;
  //     }
  //     case "CHAT_STATUS":
  //       this.parseChatStatusResponse(message);
  //       break;
  //     case "BOT_REPLY":
  //       this.parseBotReplyResponse(message);
  //       break;
  //     case "AGENT_REPLY":
  //       this.parseAgentReplyResponse(message);
  //       break;
  //     case "TYPING_INDICATOR":
  //       this.parseTypingIndicatorResponse(message);
  //       break;
  //     case "SEND_CHAT_TRANSCRIPT_RESPONSE":
  //       this.parseChatTranscriptResponse(message);
  //       break;
  //     case "CREATE_SESSION": {
  //       console.log(
  //         "SESS_BUG:12. GOT A RESPONSE FROM XMPP FOR CREATE_SESSION--->",
  //         message
  //       );
  //       this.onCreateSessionResponse(message);
  //       break;
  //     }
  //     default:
  //       break;
  //   }
  //   this.setState({ isFetchingMessagesBelow: false });
  // };

  parseMessageHistoryResponse = (message) => {
    this.setState({ showLoaderBotPopup: false });

    const isAgentConnected = localStorage.getItem("agentConnected");
    if (isAgentConnected) this.disableOnAgentConnections();
    localStorage.removeItem("autoOpenChat");
    console.log("mmm", message);
    HWLog.info("HISTORY_RESPONSE LIST MESSAGES", message);
    if (!message.listHistoryInfo || message.listHistoryInfo.length === 0) {
      this.setState({ isFetchingMessages: false });
      HWLog.info("EMPTY HiSTORY LIST");
      return;
    }
    let messagesToAdd = message.listHistoryInfo || [];
    messagesToAdd = messagesToAdd.map((i) => {
      i.id = i.id + "";
      let check = this.checkEmoji(i.message.text);
      if (i.convoType == "TEXT" && check) {
        i.convoType = "EMOJI";
      }
      return i;
    });

    console.log("messagesToAdd", messagesToAdd);

    //remove A99

    messagesToAdd.map((a) => {
      if (a?.message?.chatResponse?.entries) {
        a?.message?.chatResponse?.entries.map((entry, index) => {
          if (entry?.uiCommand === "A99")
            a?.message?.chatResponse?.entries.splice(index, 1);
          return a;
        });
      }
      return messagesToAdd;
    });

    this.addMessagesToList(messagesToAdd.reverse());
    //disabling all options apart from latest ones
    this.disablePreviousButtonsOnHistory();
  };

  parseSessionCloseResponse = (message) => {
    console.log("COMETD-LOG:SESSION CLOSE REQUESTED", message);
    // this.addEventExplicitly(true);
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    console.log(
      "SESS_BUG:3.SESSION FROM COMETD:",
      sessionId,
      "SESSION FROM CURRENT CONVERSATION :",
      activeSessionInfo.sessionId
    );
    if (activeSessionInfo.sessionId === sessionId) {
      console.log(
        "SESS_BUG:4. BOTH THE SESSIONS MATCHED!! NOW CALLING XMPP CLOSE SESSION"
      );
      // const { closeSessionCMD } = CometdActions(this.context.cometdInstance)

      // closeSessionCMD(sessionId);
      this.props.actions.markActiveConversationAsClosed();
      let sessionCloseMessage = this.getSessionCloseMessage();
      if (s360ConfigService?.config?.configDetails?.startNewSession) {
        this.addMessagesToList([sessionCloseMessage]);
      }
    } else {
      this.showSnackBarWithMessage(
        "Could not close coversation, please try again."
      );
    }
    // if(s360ConfigService?.config?.hideIcon){
    //   localStorage.removeItem("isLoggedIn")
    // }
  };

  // Add Agent Transfer Ino Message.
  parseChatStatusResponse = (message) => {
    agentNotificationMessageIds = [];
    agentNotificationMessageIdsCopy = [];
    // this.setState({ disableLoader: true });
    console.log("parseChatStatusResponse is getting called");
    this.disableOnAgentConnections();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.warn("Invalid Chat Satus Session Id: ");
      return;
    }

    let firstName = (message.agentInfo && message.agentInfo.firstName) || "";
    let lastName = (message.agentInfo && message.agentInfo.lastName) || "";
    let showAgentInfo =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.showAgentInfo;
    if (!firstName.trim() || !lastName.trim()) {
      return;
    }
    let agentName = (firstName + " " + lastName).trim();

    let messageToShow =   (!s360ConfigService.config.hideAgentName ? "You are transferred to agent " : "You are transferred to a live chat agent") + (!s360ConfigService.config.hideAgentName ? agentName : "");
    if(this.props.config.configDetails.showAgentInfo) {
      localStorage.setItem("agentName", agentName)
      window.parent.postMessage(
        {
          agentConnected: true,
          agentName: agentName,
        },
        "*"
      )
    }

    let messageTime = new Date();
    let chatInfoMessage = {
      message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
      id: "agent-info-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "TEXT",
      syntheticMessage: true,
    };

    this.addMessagesToList([chatInfoMessage]);
    // var headerVal = document.getElementsByClassName(
    //   "s360-conversation-header-details-title"
    // );
    // var headerValfs = document.getElementsByClassName(
    //   "s360-conversation-header-details-title-fs"
    // );

    // for (var i = 0; i < headerVal.length; i++) {
    //   headerVal[i].innerHTML = agentName;
    // }
    // if (headerValfs) {
    //   for (var i = 0; i < headerValfs.length; i++) {
    //     headerValfs[i].innerHTML = agentName;
    //   }
    // }
    let agentDisplayInitials =
      message.agentInfo &&
      message.agentInfo.firstName &&
      message.agentInfo.lastName
        ? message.agentInfo.firstName.charAt(0) +
          "" +
          message.agentInfo.lastName.charAt(0)
        : "B";
    // if (showAgentInfo)
    //   document.getElementById("headerImgDiv").innerHTML = agentDisplayInitials;
  };

  parseBotReplyResponse = (message) => {
    console.log("parseBotReplyResponse", message);

    this.ackBotReply(message);

    // console.log("4.TRIGERRED BOT MESSAGE", message)
    let messageTime = new Date();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
      return;
    }
    // console.log("5.TRIGERRED  BOT MESSAGE    BEFORE ADDING TO ARRAY",message)
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    message.message.sentTimestamp = messageTime.getTime();

    // console.log("6.TRIGERRED BOT MESSAGE    AFTER ADDING TO ARRAY",message)
    this.addMessagesToList([message]);
    if (this.props?.config?.notification?.isEnabled) this.audio.play();
  };

  ackBotReply = (payload) => {
    const result = { ...payload };
    result.command = "ACK_BOT_REPLY";
    console.log("ACK_BOT_REPLY", result);
    const { sendBotAckMessage } = CometdActions(this.context.cometdInstance, this.context.userData)
    sendBotAckMessage(result?.sessionId, result, "TEXT");
  };

  parseAgentReplyResponse = (message) => {
    console.log(message);

    if (message.command === "AGENT_REPLY") {
      this.ackAgentClientMsg(message);
    }

    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For AGENT REPLY: ", message || {});
      return;
    }
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    message.creator = "AGENT";

    this.addMessagesToList([message]);
    if (this.props?.config?.notification?.isEnabled) this.audio.play();
  };

  ackAgentClientMsg = (payload) => {
    const result = { ...payload };
    console.log("sendAckAgentMessage", payload);
    result.command = "ACK_AGENT_REPLY";

    // result.message.sentTimestamp = result.originalTimeStamp===undefined ? result.message.sentTimestamp:result.originalTimeStamp;
    console.log("ACK_AGENT_REPLY", result);
    result["sentTimestamp"] = result.originalTimeStamp;
    const { sendAckAgentMessage } = CometdActions(this.context.cometdInstance, this.context.userData)
    sendAckAgentMessage(result?.sessionId, result, "TEXT");
  };

  parseTypingIndicatorResponse = (message) => {
    // if it's an Agent typing then only process the request
    if (message.typer !== "AGENT")
      return
    let isTyping = message.typing || false;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For Typing Indicator: ", message || {});
      return;
    }
    this.setState({ isTyping: isTyping, showTypingIndicator: isTyping });
  };

  parseChatTranscriptResponse = (messageData) => {
    let message = messageData?.messageToUser || "The transcript is sent to your preferred Email ID";
    this.props.actions.showPopUpMessage(message);
  };

  addMessagesToList = (messagesToAdd) => {
    if (!messagesToAdd || messagesToAdd.length === 0) {
      return;
    }
    let messages = this.state.messages || [];
    let messageIds = messages.map((i) => i.id);

    let newMessagesToAdd = messagesToAdd.filter(
      (i) => i.message.text !== "IGNORE-IN-MESSAGES-ARRAY"
    );
    console.log(newMessagesToAdd, "hereee");

    // NOTE: Earlier id is different so why need filter, now id is setTimestamp so it will be unique.

    // let newMessages = newMessagesToAdd.filter((i) => {
    //   console.log("newMessages", i);
    //     return messageIds.indexOf(i.id) === -1;
    // });

    let newMessages = newMessagesToAdd;
    console.log("1.DISPLAY MESSAGES BEFORE SORTING", messages, newMessages);

    // check if next message needs to be hidden
    const shouldHideNextMsg = newMessagesToAdd.some(msg => {
      const entries = msg.message.chatResponse?.entries
      if (entries?.length > 0 && entries.some(item => item.uiCommand === "A14p"))
        return true
      return false
    })

    const isDuplicate = messages.some((msg) => {
      if (msg.msgId &&newMessagesToAdd.length>0&& newMessagesToAdd[0].msgId) {
        return msg.msgId === newMessagesToAdd[0].msgId;
      } 
    });
    console.log(isDuplicate,'dup===')
    let sortedMessagesList = isDuplicate?[...messages]:[...messages, ...newMessages];
  
    sortedMessagesList = Object.values(
      sortedMessagesList.reduce((acc, item) => {
          if (!isNaN(item.id)) { 
              acc[item.id] = item; 
          } else {
              acc[item.id] = item;
          }
          return acc;
      }, {})
  );
   
  newMessages.map((m) => console.log(m.message.sentTimestamp));

    console.log("2.DISPLAY MESSAGES AFTER SORTING", sortedMessagesList);

    let parsedMessages = this.parseMessagesForTimeStamps(sortedMessagesList);

    console.log("parsedMessages", parsedMessages);

    let canScrollToLatestMessage = this.state.isFetchingMessages !== true;

    // flushSync ensures React 18 immediately commits this state update
    // (required because this is triggered from a native CustomEvent, not a React event)
    flushSync(() => {
      this.setState(
        { messages: parsedMessages, isFetchingMessages: false, hideNextMessage: shouldHideNextMsg },
        () => {
          if (canScrollToLatestMessage) {
            this?.conversationRef?.current?.scrollToLatestMessage();
          } else {
            this?.conversationRef?.current?.scrollToLastPosition();
          }
        }
      );
    });
  };

  parseMessagesForTimeStamps = (messagesList) => {
    let messageList = [];
    let datePointer = null;
    let messages = messagesList.filter((i) => !i.syntheticDateInfoMessage); // Filter out synthetic date info messages.
    let messageIds = messages.map((i) => i.id);
    messages.forEach((message, index) => {
      if (message?.id === "session-close-message") {
        return;
      } // Filter out session close message.
      if (
        !(
          datePointer &&
          this.isOnSameDay(datePointer, message?.message?.sentTimestamp / 1000)
        )
      ) {
        let messageDateTimeText = dayjs
          .unix(message?.message?.sentTimestamp / 1000)
          .format("DD MMM YYYY");
        if (messageIds.indexOf(messageDateTimeText) === -1) {
          // Add synthetic date info message.
          messageList.push({
            message: {
              text: messageDateTimeText,
              sentTimestamp: message.message.sentTimestamp,
            },
            id: messageDateTimeText,
            type: MessageType.info,
            timestamp: message.message.sentTimestamp,
            syntheticMessage: true,
            syntheticDateInfoMessage: true,
          });
          // datePointer = message.message.sentTimestamp / 1000;
          datePointer = message.message.sentTimestamp / 1000;
        }
      }
      message.type = this.parseMessageType(message.creator);
      messageList.push(message);
    });
    if (!this.isActiveConversation()) {
      // Add session close message, if current session is closed.
      let sessionCloseMessage = this.getSessionCloseMessage();
      if (
        sessionCloseMessage &&
        s360ConfigService?.config?.configDetails?.startNewSession
      ) {
        messageList.push(sessionCloseMessage);
      }
    }
    return messageList;
  };

  parseMessageType = (creator) => {
    if (creator === "CUSTOMER") {
      return MessageType.sent;
    } else if (creator === "BOT" || creator === "AGENT") {
      return MessageType.received;
    } else {
      return MessageType.info;
    }
  };

  // MARK: New Conversation
  doMoveToNewConversation = false;
  startNewConversation = () => {
    localStorage.removeItem("agentName")
    sessionStorage.setItem("autoOpenChat", true);
    console.log("SESS_BUG:9.USER CLICKED ON NEW CONVERSATION BUTTON");
    window.parent.postMessage(
      {
        resetFromNewButton: "true",
      },
      "*"
    );

    // this.setState({isFetchingMessages:true})
    // // console.log("12.TRIGGERED NEW SEESSION WITH ID",this.props.activeConversation && this.props.activeConversation.sessionId)
    // this.doMoveToNewConversation = true;
    // console.log("SESS_BUG:10.CALLING XMPP CREATE SESSION")
    // xmppService.createSession().catch((error) => {
    //   this.showSnackBarWithMessage(
    //     "Could not close coversation, please try again."
    //   );
    //   HWLog.error(error, "New Conversation Error: ");
    //   this.doMoveToNewConversation = false;
    //   // this.setState({isFetchingMessages:false})
    //   return error;
    // });
    // console.log("SESS_BUG:11. CALLING XMPP CREATE SESSION SUCCESSFULL")
    // this.setState({isFetchingMessages:false,isReset:true})
    // console.log("13.TRIGGERED NEW SESSION API DONE")
  };

  onCreateSessionResponse = (newSessionResponse) => {
    // console.log("IN NEW SESSION LOCAL FUNCTION ",newSessionResponse)
    if (this.doMoveToNewConversation) {
      this.props.actions.startConversation(newSessionResponse, () => {
        console.log("SESS_BUG:15.RESETTING STATE AND MESSAGES TO EMPTY ARRAY");
        this.setState(
          {
            messages: [],
            xmppMessageHistory: [],
            isConversationClosed: false,
            showSnackBar: false,
            showSendChatTranscriptForm: false,
          },
          () => {
            console.log("SESS_BUG:16.CALLING XMPP CONFIGURE");
            this.configure();
            console.log("IN NEW SESSION LOCAL FUNCTION CONFIGURED ");
          }
        );
      });
    }
  };

  // MARK: AGENT HEALTH PING:
  // Start fetching health ping for every 10 seconds. Stop heath ping time on component unmount.

  agentHealthPingTimerId = null;

  //NOTE : Enhancement 5
  startFetchingHealthPings = () => {
    console.log("healthPingCounter", healthPingCounter);
    if (healthPingCounter > 2) {
      this.setState({ showReloadPopup: true });
      return;
    } else {
      healthPingCounter++;
      if (!this.isActiveConversation()) {
        return;
      }
      let sessionId = this.props.activeConversation.sessionId;
      if (!sessionId) {
        HWLog.warn("No Session Id Available To Fetch Agent Health Ping: ");
        return;
      }
      const { sendHealthPing } = CometdActions(this.context.cometdInstance, this.context.userData)
      sendHealthPing(sessionId);
    }
  };

  //Remove when we enable Enhancement
  // startFetchingHealthPings = () => {
  //   if (!this.isActiveConversation()) {
  //     return;
  //   }
  //   let sessionId = this.props.activeConversation.sessionId;
  //   if (!sessionId) {
  //     HWLog.warn("No Session Id Available To Fetch Agent Health Ping: ");
  //     return;
  //   }
  //   const { sendHealthPing } = CometdActions(this.context.cometdInstance)
  //   sendHealthPing(sessionId);
  // };

  removeHelathPingTimer = () => {
    if (this.agentHealthPingTimerId) {
      clearInterval(this.agentHealthPingTimerId);
    }
  };

  //  GREEN - Online
  //  RED - Offline
  //  Yellow - Away
  parseAgentStatusPingResponse = (message) => {
    healthPingCounter--;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info(
        "Invalid Session Id: For Agant Health Ping Response: ",
        message || {}
      );
      return;
    }
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }
    HWLog.info("AGENT PING STATUS: " + status);
    this.setState({ agentPingStatus: status });
  };

  // MARK: Actions
  actions = {
    sendMessage: (message) => this.sendMessage(message),
    sendMessageWithAttachemnts: (files, textMessage) =>
      this.sendMessageWithAttachemnts(files, textMessage),
    sendTypingStatus: (typing) => this.sendTypingStatus(typing),
    sendMessageWithCode: (textMessage, dispalyMessage) =>
      this.sendMessageWithCode(textMessage, dispalyMessage),
    disableOnAgentConnections: () => this.disableOnAgentConnections(),
    handleShowReloadPopup: () => this.handleShowReloadPopup(),
  };

  //NOTE : Enhancement 6
  handleShowReloadPopup = () => {
    console.log("handle");
    if (this?.props?.config?.healthCheck) {
      this.setState({ showReloadPopup: true, showLoaderBotPopup: false });
    }
  };

  sendTypingStatus = (typing) => {
    let sessionId =
      this.props.activeConversation && this.props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    HWLog.info("TYPING STATUS CHANGE: " + typing);
    xmppService.sendTypingIndicatorStatus(sessionId, typing).catch((error) => {
      HWLog.error(error, "Could not send typing status.");
    });
  };

  checkEmoji = (textMessage) => {
    if (!textMessage) return;
    const regexpEmojiPresentation = /\p{Emoji_Presentation}/gu;
    const regex =
      /([\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Connector_Punctuation}\p{Join_Control}]+)/gu;
    const special_char = /[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g;

    console.log("tw", textMessage);

    if (
      textMessage.match(regexpEmojiPresentation) != null &&
      textMessage.match(regexpEmojiPresentation).length == 1
    ) {
      if (
        textMessage.match(regex) == null &&
        textMessage.match(special_char) == null
      ) {
        return true;
      }
    }
    return false;
  };
  htmlToPlainText = (html) => {
    return html.toString().replace(/<\/?[^>]+(>|$)/g, "");
  };
  sendMessage = (textMessage) => {
    // this.addEventExplicitly(true);
    let sanitizedTextMessage = DOMPurify.sanitize(textMessage)
    let plainText = this.htmlToPlainText(sanitizedTextMessage);
    const { setMsgValue } = this.state;

    console.log(textMessage, "abcde");
    setTimeout(
      () => this.setState(() => ({ isFetchingMessagesBelow: false })),
      this.loaderTimeOut
    );

    const { sendMessageCMD } = CometdActions(this.context.cometdInstance, this.context.userData)

    let messageTime = new Date();

    let type = "TEXT";

    // let id = uuid()

    let id = messageTime.getTime();

    let newMessageToSend = {
      message: {
        text: plainText,
        sentTimestamp: id,
        hide: this.state.hideNextMessage,
        id: id,
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: type,
      creator: "CUSTOMER",
      syntheticMessage: true,
      // count:this.returnCount()
    };

    let pendingMsg = {
      ...setMsgValue,
    };

    // let newMessageToSend = { message: { text: textMessage }, id: uuid(), type: MessageType.received, timestamp: messageTime.getTime(), convoType: "TEXT", creator: "BOT", syntheticMessage: true }
    let sessionInfo = this.props.activeConversation;
    let message = {
      text: plainText,
      sentTimestamp: id,
      id: id,
    };
    //       let message = { text: textMessage, sentTimestamp: messageTime.getTime() }
    // console.log("CALLING SEND MESSAGE API ")
    //TODO : MAKE THE LOADER TRUE
    this.setState({
      messageLoader: true,
      isFetchingMessagesBelow: true,
      showMessagesFromStart: false,
      setMsgValue: { ...pendingMsg, [id]: newMessageToSend },
      showAckMsg: true,
      hideNextMessage: false
    });

    // console.log("2.TRIGERRED SEND MESSAGE    BEFORE ADDING TO ARRAY",newMessageToSend)
    if (
      textMessage === s360ConfigService?.config?.mainMenuMessage &&
      s360ConfigService?.config?.restartOnMainMenu
    ) {
      this.setState({ messages: [] });
    } else {
      this.addMessagesToList([newMessageToSend]);
      // console.log("3.TRIGERRED SEND MESSAGE    AFTER ADDING TO ARRAY",newMessageToSend)

      console.log("newMessageToSend to cometD", message);
    }

    sendMessageCMD(sessionInfo.sessionId, message, "TEXT");
    this.handleUpdateTypingStatus(false)
  };

  handleCustomerRetryMsg = (msg) => {
    const { sendMessageCMD } = CometdActions(this.context.cometdInstance, this.context.userData)

    const payload = { ...msg };

    console.log("handleCustomerRetryMsg", msg);

    let newMessageToSend = {
      ...payload,
    };

    let sessionInfo = this.props.activeConversation;

    let message = {
      ...payload.message,
    };

    // let message = {
    //   text: payload.message.text,
    //   sentTimestamp: payload.message.sentTimestamp,
    //   id: payload.message.sentTimestamp,
    // };

    this.setState({
      isFetchingMessagesBelow: true,
      showMessagesFromStart: false,
      // setMsgValue: newMessageToSend,
      showAckMsg: true,
    });

    console.log("handleCustomerRetryMsg to cometD", message, newMessageToSend);

    sendMessageCMD(sessionInfo.sessionId, message, msg.convoType);

    this.timerLoader(2000);
  };

  timerLoader = (time) => {
    this.setState({
      isFetchingMessagesBelow: true,
    });
    setTimeout(() => {
      this.setState({
        isFetchingMessagesBelow: false,
      });
    }, time);
  };

  parseFileTypeToSend = (file) => {
    if (file.type.toLowerCase().indexOf("audio") !== -1) {
      return "audio";
    } else if (file.type.toLowerCase().indexOf("video") !== -1) {
      return "video";
    } else if (file.type.toLowerCase().indexOf("image") !== -1) {
      return "image";
    } else {
      return "document";
    }
  };

  sendMessageWithAttachemnts = (attachedFiles, textMessage) => {
    console.log("CALLING MESSAGE WITH ATTACHMENTS API", attachedFiles);
    //TODO MAKE THE LOADER FALSE
    this.setState({ messageLoader: true, isFetchingMessagesBelow: true });

    const { setMsgValue } = this.state;

    let sessionInfo = this.props.activeConversation;
    let messageAttachments = [];
    let messageTime = new Date();

    let id = messageTime.getTime();

    let fileUploadTasks = attachedFiles.map((file, index) => {
      let newfileType = this.parseFileTypeToSend(file);

      console.log("fileType", file, newfileType);

      return apiService
        .uploadMedia(file, newfileType, sessionInfo.sessionId)
        .then(
          (result) => {
            console.log("result", result);
            let mediaMessage = {
              message: {
                text: result.data.url,
                sentTimestamp: id,
                id: id,
              },
              id: id + index,
              type: MessageType.sent,
              timestamp: id,
              convoType: newfileType.toUpperCase(),
              creator: "CUSTOMER",
              // syntheticMessage: true,
            };

            this.setState({
              messageLoader: false,
              isFetchingMessagesBelow: false,
            });

            console.log("mediaMessage", mediaMessage, newfileType);

            // this.addMessagesToList([mediaMessage]);
            messageAttachments.push(mediaMessage);
            return result;
          },

          (error) => {
            console.log(
              "CALLING MESSAGE WITH ATTACHMENTS API FAILED ",
              error.response
            );
            this.showSnackBarWithMessage(
              "Something went wrong, Please check your internet connection"
            );
          }
        );
    });

    console.log("fileUploadTasks", fileUploadTasks);

    return Promise.all(fileUploadTasks)
      .then((result) => {
        console.log("resulttt", result);
        this.setState({ messageLoader: true, isFetchingMessagesBelow: true });

        // if (textMessage && textMessage.trim()) {
        //   let newMessageToSend = {
        //     message: {
        //       text: textMessage,
        //       sentTimestamp: messageTime.getTime(),
        //       id: messageTime.getTime(),
        //     },
        //     id: messageTime.getTime(),
        //     type: MessageType.sent,
        //     timestamp: messageTime.getTime(),
        //     convoType: this.fileType.toUpperCase(),
        //     creator: "CUSTOMER",
        //     syntheticMessage: true,
        //   };
        //   console.log("newMessageToSend", newMessageToSend);
        //   messageAttachments.push(newMessageToSend);
        // }

        const { sendMessageCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
        let sendMessageTasks = messageAttachments.map((messageItem, index) => {
          console.log("messageItemmessageItem", messageItem);
          let message = {
            text: messageItem.message.text,
            sentTimestamp: id,
            id: id + index,
          };
          let convoType = messageItem.convoType;

          console.log("convoTypeconvoType", messageItem, convoType);

          sendMessageCMD(sessionInfo.sessionId, message, convoType);
          this.addMessagesToList([messageItem]);

          let pendingMsg = {
            ...setMsgValue,
          };

          this.setState({
            setMsgValue: {
              ...pendingMsg,
              [id + index]: {
                message: {
                  text: messageItem.message.text,
                  sentTimestamp: id,
                  id: id + index,
                },
                id: id + index,
                type: MessageType.sent,
                timestamp: id,
                convoType: convoType,
                creator: "CUSTOMER",
                syntheticMessage: true,
              },
            },
            showAckMsg: true,
          });
        });

        this.setState({
          messageLoader: false,
          isFetchingMessagesBelow: false,
        });

        console.log("sendMessageTasks", sendMessageTasks);

        // return Promise.all(sendMessageTasks);
      })
      .catch((error) => {
        console.log("attchment error", error);
        console.log("Could Not Send Message");
      });
  };

  getSessionCloseMessage = () => {
    let sessionCloseMessage =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.sessionCloseMessage;
    if (!sessionCloseMessage) {
      HWLog.warn("Session Close Message Not Available In Config:");
      return null;
    }
    let messageTime = new Date();
    let sessionCloseMessageToAdd = {
      message: {
        text: sessionCloseMessage,
        sentTimestamp: messageTime.getTime(),
      },
      id: "session-close-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "CLOSE",
      syntheticMessage: true,
    };
    return sessionCloseMessageToAdd;
  };

  // MARK: Handle Conversation Messages Pagination
  // onScrollToConversationTop = () => {
  //   HWLog.info("SCROLLED TO TOP:");
  //   this.fetchPreviousPageMessages();
  // };

  fetchPreviousPageMessages = () => {
    if (this.state.isFetchingMessages) {
      return;
    }

    let messageHistory = (this.state.messages || []).filter(
      (i) => !i.syntheticMessage
    );
    if (messageHistory.length === 0) {
      return;
    }
    let lastFetchMessage = messageHistory[0];
    if (!lastFetchMessage || !lastFetchMessage.id) {
      return;
    }
    this.setState({ isFetchingMessages: true }, () => {
      this.fetchConversationHistory(lastFetchMessage.id).catch((error) => {
        this.setState({ isFetchingMessages: false });
      });
    });
  };

  // MARK:  Style Functions
  conversationStyle = () => {
    const isFullScreen = localStorage.getItem("openInFullScreen");
    return {
      maxHeight: isFullScreen ? "100%" : "100%",
    };
  };

  containerStyle = () => {
    let config = this.props.config;
    let height = window.screen.height * 0.75;
    // let height = window.screen.height * 0.34;
    const styles = {
      // position: 'relative',
      backgroundColor: config.designDetails.pageBackgroundColor,
      height: localStorage.getItem("openInFullScreen") ? "85%" : "100%",
      backgroundImage:
        config?.designDetails?.conversationBackground &&
        config?.designDetails.conversationBackground !== ""
          ? `url(${
              config?.designDetails?.conversationBackground &&
              config?.designDetails.conversationBackground
            })`
          : config.designDetails.pageBackgroundColor,
      paddingLeft:
        config.designDetails.padding && !isMobile
          ? `${config.designDetails.padding}%`
          : "0%",
      paddingRight:
        config.designDetails.padding && !isMobile
          ? `${config.designDetails.padding}%`
          : "0%",
    };
    if (!!config.designDetails?.hideCardBoxShadow) {
      styles['boxShadow'] = 'none';
    }

    return styles;
  };

  sendMessageWithCode = (textMessage, dispalyMessage) => {
    // this.addEventExplicitly(true);
    // console.log("1.TRIGERRED SEND MESSAGE IN CODE ");
    console.log(textMessage, dispalyMessage, "year check");

    const { setMsgValue } = this.state;
   
    const { sendMessageCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
    //    this.parseTypingIndicatorResponse({"configId":710,"sessionId":this.props.activeConversation.sessionId,"command":"TYPING_INDICATOR","typer":"AGENT","typing":true,"fromUi":false,"sourceType":0,"isJabber":false,"fromApi":false});
    let messageTime = new Date();
    let id = messageTime.getTime();
    let newMessageToSend = {
      message: {
        text:
          typeof dispalyMessage === "object"
            ? dispalyMessage.name
            : dispalyMessage,
        sentTimestamp: id,
        id: id,
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: "TEXT",
      creator: "CUSTOMER",
      syntheticMessage: true,
      // count:this.returnCount()
    };
    let sessionInfo = this.props.activeConversation;
    let message = {
      text:
        typeof dispalyMessage === "object" ? dispalyMessage.value : textMessage,
      sentTimestamp: id,
      id: id,
    };
    console.log(message, "thums up message");
    // console.log("2.TRIGERRED SEND MESSAGE IN CODE BEFORE ADDING ARRAY ");
    this.addMessagesToList([newMessageToSend]);
    // console.log("3.TRIGERRED SEND MESSAGE IN CODE AFTER ADDING ARRAY ");
    //TODO:INTRODUCE SOME LAG HERE

    let pendingMsg = {
      ...setMsgValue,
    };

    this.setState({
      messageLoader: true,
      isFetchingMessagesBelow: true,
      // setMsgValue: newMessageToSend,
      setMsgValue: { ...pendingMsg, [id]: newMessageToSend },
      showAckMsg: true,
    });
    sendMessageCMD(sessionInfo.sessionId, message, "TEXT");
  
    if (["50", "51", "52", "53", "54", "55", "56"].includes(textMessage)) {
      this.context.updateMainMenuMessage(
        MAIN_MENU_MESSAGE[this.props.config?.mainMenuMessage || "Main Menu"]?.[dispalyMessage || "English"] || this.props.config?.mainMenuMessage || "Main Menu"
      );
    }
  };

  getModalBtnStyles = () => {
    let config = this.props.config;
    return {
      background: config.designDetails.selectionButtonColor,
      color: config.designDetails.selectionButtonTextColor,
      fontFamily: config.designDetails.selectionButtonFont,
      fontSize: config.designDetails.selectionButtonFontSize + "px",
      padding: "5px 16px",
      cursor: "pointer"
    };
  }

  setGifValueToList = (value) => {
    this.setState({ setMsgValue: value });
  };

  handleSessionReloadClose = () => {
    this.setState({ showReloadPopup: false });
  };

  handleSessionReload = () => {
    //NOTE : Enhancement 7
    if (this?.props?.config?.healthCheck) {
      this.setState({
        showLoaderBotPopup: true,
        showErrorMsg: "Please wait while fetching the messages",
      });
      healthPingCounter = 0;
    }

    this.setState({ messages: [] });
    this.fetchConversationHistoryCometd();
    this.setState({ showReloadPopup: false });
  };
  switchBot = () => {
    this.closeConversationClick();
    window.parent.postMessage(
      {
        switchBot: "true",
      },
      "*"
    );
  };

  render() {
    // console.log("null")
    const isFullScreen = localStorage.getItem("openInFullScreen");
    const {
      showChatStatusLang,
      showChatStatusAttachment,
      showReloadPopup,
      showLoaderBotPopup,
      showErrorMsg,
    } = this.state;

    return (
      <div
        className="s360-conversation-page"
        style={this.conversationStyle()}
        id="s360-conversation-page"
      >
        {showLoaderBotPopup ? (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "80vh",
            }}
          >
            <CircularProgress />
            <p
              style={{
                position: "absolute",
                marginTop: " 11rem",
                fontWeight: 500,
                width: "75%",
              }}
            >
              {showErrorMsg}
            </p>
          </span>
        ) : (
          <>
            <ConversationHeader
              {...this.props}
              {...this.state}
              isActiveConversation={this.isActiveConversation}
              startNewConversation={this.startNewConversation}
              closeConversation={this.closeConversation}
              onSendChatTranscriptClick={this.onSendChatTranscriptClick}
              closeConversationClick={this.closeConversationClick}
              isShowToggle={showChatStatusLang}
              sessionId={this.props.activeConversation.sessionId}
              onShowSetting={this.showSetting}
            />
            {showReloadPopup && this.props.activeConversation.active && (
              <ReloadSessionContainer
                handleSessionReload={() => this.handleSessionReload()}
                handleSessionReloadClose={() => this.handleSessionReloadClose()}
              />
            )}
            <div
              className={
                isFullScreen
                  ? "s360-conversation-page-container-fs"
                  : "s360-conversation-page-container"
              }
              id="conver"
              style={this.containerStyle()}
            >
              <Conversation
                switchBot={this.switchBot}
                disableLoader={this.state.disableLoader}
                messagesLength={this.state.messages.length}
                parseSessionClose={this.parseSessionCloseResponse}
                isFetchingMessages={this.state.isFetchingMessages}
                messageLoader={this.state.messageLoader}
                // TODO :PASS LOADER TO THIS Component -DONE
                ref={this.conversationRef}
                onScrollToConversationTop={this.onScrollToConversationTop}
                {...this.props}
                {...this.state}
                actions={{ ...this.props.actions, ...this.actions }}
                startNewConversation={this.startNewConversation}
                isFetchingMessagesBelow={this.state.isFetchingMessagesBelow}
                customerAckObj={this.state.customerAckObj}
                handleCustomerRetryMsg={this.handleCustomerRetryMsg}
              />

              {/* show typing indicator */}
              {this.state.showTypingIndicator && <TypingIndicator />}
            </div>
            <div>
              {this.state.showGif && (
                <Popup
                  handleClose={this.handleClose}
                  addMessagesToList={this.addMessagesToList}
                  addSetMsgValue={this.setGifValueToList}
                  {...this.props}
                />
              )}
            </div>

            {this.isActiveConversation() && (
              <InputBox
                {...this.props}
                {...this.actions}
                finalValue={this.state.finalValue}
                setRef={this.messageRef}
                send={this.onMessageSend}
                disableInput={this.state.previewFiles.length > 0}
                handleUpdateTypingStatus={this.handleUpdateTypingStatus.bind(this)}
                attachmentSVGImage={this.attachmentSVGImage}
                showChatStatusAttachment={showChatStatusAttachment}
              />
            )}
            <Modal
              show={this.state.showSetting}
              closeModal={() => this.setState({ showSetting: false })}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                <span style={{ marginBottom: "7px", color: "#687882" }}>
                  Press <span class="keyboard-key">Enter</span> to…
                </span>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <label for="sendIt" className="modal-label">
                    <input
                      id="sendIt"
                      name="enter"
                      type="radio"
                      style={{ marginRight: "5px", cursor: "pointer" }}
                      onChange={this.handleRadio}
                      checked={this.state.radioValue === "sendIt"}
                    />
                    Send the message
                  </label>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <label for="newLine" className="modal-label">
                    <input
                      id="newLine"
                      name="enter"
                      type="radio"
                      style={{ marginRight: "5px", cursor: "pointer" }}
                      onChange={this.handleRadio}
                      checked={this.state.radioValue === "newLine"}
                    />
                    Start a new line
                  </label>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", marginTop: "10px" }}>
                  <button
                    onClick={() => this.setState({ showSetting: false })}
                    style={this.getModalBtnStyles()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </Modal>
            {this.state.previewFiles.length > 0 && (
              <PreviewAttachmentFiles
                {...this.props}
                {...this.state}
                onRemovePreviewFile={this.onRemovePreviewFile}
                onAddPreviewFile={this.onFileSelect}
                files={this.state.previewFiles}
              />
            )}
            <div
              className={
                isFullScreen
                  ? "s360-conversation-page-footer-container-fs"
                  : "s360-conversation-page-footer-container"
              }
              style={ this.props.config.designDetails?.hideOptionsFooter ? { display: "none" } : {} }
            >
              <div
                className={
                  isFullScreen
                    ? "s360-conversation-page-footer-tool-container-fs"
                    : "s360-conversation-page-footer-tool-container"
                }
              >
                {this.props.config.showReset ? (
                  <button
                    className="s360-input-box-home"
                    id="home"
                    aria-label="Return to Main Menu"
                    onClick={() =>
                      this.props.config.isHome
                        ? this.sendMessage(
                            isNullOrUndefined(
                              this?.props?.config?.mainMenuMessage
                            )
                              ? "I would like to Return to main menu"
                              : this.context.mainMenuMessage
                          )
                        : this.resetChat()
                    }
                  >
                    <Tooltip
                      title={
                        <Typography fontSize={12}>
                          {this.props.config.isHome
                            ? this?.props?.config?.mainMenuMessage
                              ? "I would like to Return to main menu"
                              : this?.props?.config?.mainMenuMessage
                            : " Reset chat"}
                        </Typography>
                      }
                    >
                      <img
                        disable={this.state.isReset}
                        style={{
                          width: "21px",
                          height: "21px",
                          cursor: "pointer",
                          opacity: this.state.isReset ? 0.5 : 1,
                        }}
                        src={this.props.config.designDetails?.showMenuStyleMainMenuIcon ? menuIcon : this.props.config.isHome ? homeImage : resetImage}
                        alt="/"
                      ></img>
                    </Tooltip>
                  </button>
                ) : null}
                {this.props.config.showEmoji ? (
                  <button
                    className="s360-input-box-emoji"
                    id="emoji"
                    onClick={this.showEmoji}
                    aria-label="Show Emojis panel"
                  >
                    {this.emojiSVGImage(
                      this.props.config.designDetails.innerButtonSVGColor
                    )}
                  </button>
                ) : null}
                <div>
                  {this.state.showEmoji && (
                    <Picker
                      disableSkinTonePicker
                      onEmojiClick={this.onEmojiClick}
                      groupVisibility={{
                        flags: false,
                        animals_nature: false,
                        food_drink: false,
                        travel_places: false,
                        activities: false,
                        objects: false,
                        symbols: false,
                      }}
                      pickerStyle={{
                        position: "absolute",
                        top: "115px",
                        left: "9px",
                        width: "93%",
                        zIndex: "99999",
                      }}
                      ref={this.emojiRef}
                    />
                  )}
                </div>

                {this.props.config.showGif ? (
                  <button
                    className="s360-input-box-gif"
                    id="gif"
                    onClick={this.showGIF}
                    aria-label="Show GIFs"
                  >
                    <img
                      style={{
                        width: "25px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                      src={gifImage}
                      alt="/"
                    ></img>
                  </button>
                ) : null}
                {showChatStatusAttachment && (
                  <button
                    className={
                      isFullScreen
                        ? "s360-input-box-attachment-fs"
                        : "s360-input-box-attachment"
                    }
                    onClick={() => this.file.current.click()}
                  >
                    <input
                      style={{ opacity: "0", width: "1px", display: "none" }}
                      ref={this.file}
                      type="file"
                      multiple="multiple"
                      aria-label="Attach files"
                      onChange={this.onFileSelect}
                      onKeyPress={this.handleKeyPress}
                      className="UploadFile image_uploader"
                      // accept="image/*, video/*, audio/*, .doc,.docx, .pdf, .xls, .txt, .ppt, .xlsx, .csv,.ogg, .pdf, .png, .ppt, .pptx, .rar, .tif, .tiff, .wav, .xls, .xlsx, .xps, .zip"
                    />
                    <img 
                      src={this.attachmentSVGImage(
                        !!this.props.config.designDetails.showPinStyleAttachmentIcon
                      )}
                    />
                  </button>
                )}
                
                <div className="s360-input-box-setting">
                  {this.props.config.configDetails?.hideSettingButton ? null : (
                    <img
                      style={{
                        width: "18px",
                        height: "27px",
                        cursor: "pointer",
                      }}
                      src={settingImage}
                      alt="/"
                      onClick={this.showSetting}
                    />
                  )}
                </div>
              </div>
              <DefaultFooter 
                {...this.props} 
                conversationFooterRef={this.conversationFooterRef}
               />
            </div>
            <Snackbar
              open={this.state.showSnackBar}
              onClose={this.handleSnackbarClose}
              message={this.state.snackBarMessage}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              key={"bottom-right-snackbar"}
              autoHideDuration={3000}
            />
            {this.state.showSendChatTranscriptForm && (
              <SendChatTranscriptForm
                {...this.props}
                {...this.state}
                onSendChatTranscript={this.sendChatTranscript}
                onClose={() => {
                  this.setState({ showSendChatTranscriptForm: false });
                }}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

export default ConversationPage;
